// import api from '🔗/api';

export const OGG_HEADER_SIZE = 27;
export const OGG_PAGES_PER_CHUNK = 678;
export const KERNEL_BUFFER_SIZE = 1024;
export const OGG_PRELOAD_CHUNK_COUNT = 1;

// export const calcOggPageSize = (buffer) => {
//     const view = new Uint8Array(buffer);
//     if (view.byteLength < OGG_HEADER_SIZE) {
//         return 0;
//     }

//     const segmentCount = view[26];
//     if (view.byteLength < OGG_HEADER_SIZE + segmentCount) {
//         return 0;
//     }

//     const segmentTable = view.slice(OGG_HEADER_SIZE, OGG_HEADER_SIZE + segmentCount);
//     const payloadLength = Array.from(segmentTable).reduce((a, b) => a + b, 0);

//     const totalSize = OGG_HEADER_SIZE + segmentCount + payloadLength;
//     if (view.byteLength < totalSize) {
//         return 0; // проверка на неполный буфер
//     }

//     return totalSize;
// };

export const calcOggPageSize = (buffer) => {
    const view = new Uint8Array(buffer);
    if (view.byteLength < 27) return 0;

    const segmentCount = view[26];
    if (view.byteLength < 27 + segmentCount) return 0;

    let payloadLength = 0;
    for (let i = 0; i < segmentCount; i++) {
        payloadLength += view[27 + i];
    }

    const totalSize = 27 + segmentCount + payloadLength;
    if (view.byteLength < totalSize) return 0;

    return totalSize;
};

export const mergeBuffer = (a, b) => {
    const merged = new Uint8Array(a.length + b.length);
    merged.set(a, 0);
    merged.set(b, a.length);
    return merged;
};

// Ищем в буфере пакеты содержащие "vorbis" с типами 0x01,0x03,0x05 (идентификация, комменты, setup).
// Эта простая реализация ищет байтовую подпоследовательность "\x01vorbis", "\x03vorbis", "\x05vorbis"
// и возвращает offset, сразу после страницы, содержащей setup (если найдено).
export const findOggHeaderEnd = (buffer) => {
    const view = new Uint8Array(buffer);

    let offset = 0;
    let foundSetup = false;

    // проход по страницам Ogg (на самой надёжной реализации — нужно парсить segment table; тут - упрощение)
    while (offset + OGG_HEADER_SIZE <= view.length) {
        if (view[offset] !== 0x4f || view[offset+1] !== 0x67 || view[offset+2] !== 0x67 || view[offset+3] !== 0x53) {
            // не "OggS" — выходим
            break;
        }

        const segmentCount = view[offset + 26];
        const segTableStart = offset + OGG_HEADER_SIZE;
        if (segTableStart + segmentCount > view.length) {
            break;
        }

        // суммируем длину полезной части
        let payloadLen = 0;
        for (let i = 0; i < segmentCount; i++) {
            payloadLen += view[segTableStart + i];
        }

        const pageEnd = segTableStart + segmentCount + payloadLen;

        // Извлекаем payload этой страницы и ищем в нём маркеры vorbis-хедеров
        const payloadStart = segTableStart + segmentCount;

        if (payloadStart + 7 <= view.length) {
            // ищем последовательности: 0x01 'vorbis', 0x03 'vorbis', 0x05 'vorbis'
            for (let i = payloadStart; i + 6 < Math.min(pageEnd, view.length); i++) {
                // проверка формата: тип пакета и "vorbis"
                if (view[i] >= 0x01 && view[i] <= 0x05 &&
                    view[i+1] === 0x76 && view[i+2] === 0x6f && view[i+3] === 0x72 &&
                    view[i+4] === 0x62 && view[i+5] === 0x69 && view[i+6] === 0x73) {
                    // тип пакета
                    const pktType = view[i];
                    if (pktType === 0x05) {
                        // нашли setup — считаем, что после этой страницы заголовки закончились
                        foundSetup = true;
                    }
                }
            }
        }

        offset = pageEnd; // переход к следующей странице

        if (foundSetup) {
            // вернём конец страницы, которая содержала setup
            return offset;
        }
    }

    // если не нашли — возврат 0 (ещё не достаточно данных)
    return 0;
};

export function parseOggVorbisHeader(buffer) {
    const view = new Uint8Array(buffer);
    const OGGS = [0x4f, 0x67, 0x67, 0x53]; // "OggS"
    const VORBIS = [0x76,0x6f,0x72,0x62,0x69,0x73]; // "vorbis"

    let offset = 0;

    while (offset + 30 < view.length) {
        // ищем "OggS"
        if (view[offset] === OGGS[0] &&
            view[offset+1] === OGGS[1] &&
            view[offset+2] === OGGS[2] &&
            view[offset+3] === OGGS[3]) {

            const segmentCount = view[offset + 26];
            const segTableStart = offset + 27;
            if (segTableStart + segmentCount > view.length) break;

            // суммируем длину полезной части
            let payloadLen = 0;
            for (let i = 0; i < segmentCount; i++) {
                payloadLen += view[segTableStart + i];
            }

            const pageEnd = segTableStart + segmentCount + payloadLen;
            const payloadStart = segTableStart + segmentCount;

            // ищем Identification header: 0x01 + "vorbis"
            for (let i = payloadStart; i + 6 < Math.min(pageEnd, view.length); i++) {
                if (view[i] === 0x01 &&
                    view[i+1] === VORBIS[0] &&
                    view[i+2] === VORBIS[1] &&
                    view[i+3] === VORBIS[2] &&
                    view[i+4] === VORBIS[3] &&
                    view[i+5] === VORBIS[4] &&
                    view[i+6] === VORBIS[5]) {

                    // Количество каналов — 1 байт после пакета и "vorbis"
                    const channelCount = view[i + 11];

                    // Sample rate — 4 байта little-endian
                    const sampleRate = view[i + 12] |
                                       (view[i + 13] << 8) |
                                       (view[i + 14] << 16) |
                                       (view[i + 15] << 24);

                    return { channelCount, sampleRate };
                }
            }

            offset = pageEnd;
        } else {
            offset++;
        }
    }

    // если не нашли Identification header
    return null;
}

export const resampleBuffer = async (buffer, targetSampleRate) => {
    if (buffer.sampleRate === targetSampleRate) {
        return buffer;
    }

    const offlineCtx = new OfflineAudioContext(
        buffer.numberOfChannels,
        Math.ceil(buffer.length * targetSampleRate / buffer.sampleRate),
        targetSampleRate
    );

    const source = offlineCtx.createBufferSource();
    source.buffer = buffer;
    source.connect(offlineCtx.destination);
    source.start();

    return await offlineCtx.startRendering();
}

export const findOggPageStart = (buffer) => {
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.length - 3; i++) {
        if (
            bytes[i] === 0x4F && // 'O'
            bytes[i + 1] === 0x67 && // 'g'
            bytes[i + 2] === 0x67 && // 'g'
            bytes[i + 3] === 0x53 // 'S'
        ) {
            return i;
        }
    }

    return -1;
}

export const processChunk = (pane, view) => {
    let offset = 0;
    let lastComplete = 0;

    while (offset + 27 <= view.length) {
        // calcOggPageSize inline (как у тебя)
        const segmentCount = view[offset + 26];
        if (offset + 27 + segmentCount > view.length) break;

        let payloadLength = 0;
        for (let i = 0; i < segmentCount; i++) {
            payloadLength += view[offset + 27 + i];
        }
        const pageSize = 27 + segmentCount + payloadLength;
        if (offset + pageSize > view.length) break;

        offset += pageSize;
        lastComplete = offset;
    }

    if (lastComplete > 0) {
        // append full pages into _dataBuffer
        const newData = new Uint8Array(pane._dataBuffer.length + lastComplete);
        newData.set(pane._dataBuffer, 0);
        newData.set(view.subarray(0, lastComplete), pane._dataBuffer.length);
        pane._dataBuffer = newData;
        pane._position += lastComplete;
    }
}

export const fetchRange = async (pane, start = 0, end = null) => {
    const headers = {};

    if (end !== null) {
        headers.Range = `bytes=${start}-${end}`;
    }

    const startTime = performance.now();

    let buf;

    if (!pane._item.type || pane._item.type === 'track') {
        const payload = await api.tracks().stream(pane._item.id, pane.format(), headers.Range);
        buf = payload?.data;

        if (payload.range?.total && payload.range?.end) {
            if (payload.range.end >= payload.range.total - 2) {
                pane._allChunksLoaded = true;
            } else {
                pane._allChunksLoaded = false;
            }
            pane._durationInBytes = payload.range.total;
        }
    }

    const endTime = performance.now();

    if (!buf) {
        return;
    }

    const speed = buf.byteLength / ((endTime - startTime) / 1000) / 1024 / 1024; // MB/s

    // если скорость низкая — переключаемся на ogg
    if (pane.lossless === null) {
        if (speed < 0.5 && /wav/i.test(pane.format())) {
            pane.format('ogg');
        } else if (speed > 2 && /ogg/i.test(pane.format())) {
            pane.format('wav');
        }
    }

    return buf;
}

export const fetchUnit = async (pane, mode) => {
    if (pane.format() === 'wav') {
        const start = pane._position;
        const end = start + 128 * 1024 - 1;
        const buf = await fetchRange(pane, start, end);

        return buf;
    } else if (pane.format() === 'ogg') {
        const pageSize = 58; // await pane.pageSize(); Не критично
        const start = pane._position;

        let end;
        if (mode === 'header') {
            end = start + pageSize * 100 - 1;
        } else {
            end = start + pageSize * OGG_PAGES_PER_CHUNK * (['fast', 'seek'].indexOf(mode) !== -1 ? 1 : 2) - 1;
        }

        const buf = await fetchRange(pane, start, end);
        return buf;
    }
}

export const findOggHeader = async (pane) => {
    let oggHeader;
    try {
        pane._position = 0;
        const chunk = await fetchUnit(pane, 'header');
        if (!chunk || chunk.byteLength === 0) {
            return false;
        }

        const headerEnd = findOggHeaderEnd(chunk);

        if (headerEnd > 0 && headerEnd <= chunk.byteLength) {
            oggHeader = chunk.slice(0, headerEnd);
        }
    } catch (err) {
    }   
    return oggHeader;
}

export const loadChunk = async (pane, id, mode) => {
    if (pane._allChunksLoaded) {
        return;
    }

    try {
        const chunk = await fetchUnit(pane, mode);
        if (!chunk || chunk.byteLength === 0) {
            return;
        } else {
            if (!id || id === pane._item?.id) {
                if (mode === 'seek' && pane._seekLock) {
                    processChunk(pane, new Uint8Array(chunk));
                } else if (mode !== 'seek' && pane._seekLock) {
                    return;
                } else {
                    processChunk(pane, new Uint8Array(chunk));
                }
            }
        }

        return chunk;
    } catch (err) {
        return;
    }
}

export const generateSilentWav = (durationSeconds = 10, sampleRate = 4000) => {
    const numSamples = durationSeconds * sampleRate;
    const buffer = new ArrayBuffer(44 + numSamples * 2);
    const view = new DataView(buffer);

    function writeString(view, offset, str) {
        for (let i = 0; i < str.length; i++) {
            view.setUint8(offset + i, str.charCodeAt(i));
        }
    }

    writeString(view, 0, 'RIFF');
    view.setUint32(4, 36 + numSamples * 2, true);
    writeString(view, 8, 'WAVE');
    writeString(view, 12, 'fmt ');
    view.setUint32(16, 16, true); // PCM chunk size
    view.setUint16(20, 1, true);  // PCM format
    view.setUint16(22, 1, true);  // num channels
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * 2, true); // byte rate
    view.setUint16(32, 2, true); // block align
    view.setUint16(34, 16, true); // bits per sample
    writeString(view, 36, 'data');
    view.setUint32(40, numSamples * 2, true);

    // Данные — все нули (молчание)
    for (let i = 0; i < numSamples; i++) {
        view.setInt16(44 + i * 2, 0, true);
        // view.setInt16(44 + i * 2, 0, true);
    }

    return URL.createObjectURL(new Blob([buffer], { type: 'audio/wav' }));
}

export const contributorsPreview = (contrubutors) => {
    if (!contrubutors?.length) {
        return;
    }

    const primaryArtists = contrubutors?.filter(item =>
        item.role === 'PRIMARY' && (item.artist?.name || item.unregisteredArtistName)).map(item => ({
            name: item.artist?.name || item.unregisteredArtistName,
            id: item.state === 'CONFIRMED' ? item.artist?.id : null
        })) || [];

    const featArtists = contrubutors?.filter(item =>
        item.role === 'FEATURED' && (item.artist?.name || item.unregisteredArtistName)).map(item => ({
            name: item.artist?.name || item.unregisteredArtistName,
            id: item.state === 'CONFIRMED' ? item.artist?.id : null
        })) || [];

    let result = primaryArtists.map(item => item.name).join(', ');

    if (featArtists?.length) {
        result += ` feat. ${featArtists.map(item => item.name).join(', ')}`;
    }

    return result;
}
